import { FC, SVGProps } from 'react';

const Download: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 17.2458C11.834 17.2458 11.6748 17.1773 11.5575 17.0555L7.8075 13.1706C7.56311 12.9175 7.56311 12.507 7.8075 12.2538C8.05189 12.0006 8.44811 12.0006 8.6925 12.2538L11.375 15.0341V3.64748C11.375 3.28989 11.6548 3 12 3C12.3452 3 12.625 3.28989 12.625 3.64748V15.0341L15.3075 12.2538C15.5519 12.0006 15.9481 12.0006 16.1925 12.2538C16.4369 12.507 16.4369 12.9175 16.1925 13.1706L12.4425 17.0555C12.3252 17.1773 12.166 17.2458 12 17.2458ZM3.25 15.1727C3.25 14.8151 2.97018 14.5252 2.625 14.5252C2.27982 14.5252 2 14.8151 2 15.1727V18.4101C2 19.8405 3.11929 21 4.5 21H19.5C20.8807 21 22 19.8405 22 18.4101V15.1727C22 14.8151 21.7202 14.5252 21.375 14.5252C21.0298 14.5252 20.75 14.8151 20.75 15.1727V18.4101C20.75 19.1253 20.1904 19.705 19.5 19.705H4.5C3.80964 19.705 3.25 19.1253 3.25 18.4101V15.1727Z"
      fill="currentColor"
    />
  </svg>
);

export default Download;
